import React from 'react';
import '../template-file-css/document-file-template.css';


export const GFIT_VerifiedDiagnosisForm = ({ itemsRef, howErrorFor, }) => {

    return (
        <form id='GFIT_VerifiedDiagnosisForm' className='file-pdf-document'>
            <div className='file-template'>


                <table>

                    <tr>
                        <td className='w-750'>
                            <center> <b> Verified Diagnosis Summary </b> </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <center> <b> CONFIDENTIAL </b> </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Patient </span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> HIPAA Code </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input type='text' id='txtPatient_1' name='txtPatient1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtHippaCode_1' name='txtHippaCode1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Age </span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Units </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input type='text' id='txtAge_1' name='txtAge1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtUnits_1' name='txtUnits1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Date of Birth </span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Gender </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input type='date' id='txtDateOfBirth_1' name='txtDateOfBirth1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtGender_1' name='txtGender1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'> Date of Interview </span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'> Time In </span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'> Time Out </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtDateOfInterview_1' name='txtDateOfInterview1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='time' id='txtTimeIn_1' name='txtTimeIn1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='time' id='txtTimeOut_1' name='txtTimeOut1' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Education </span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Clinician Name </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input type='text' id='txtEducation_1' name='txtEducation1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtClinicianName_1' name='txtClinicianName1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Report Date </span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Medicaid Number </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input type='text' id='txtReportDate_1' name='txtReportDate1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidNumber_1' name='txtMedicaidNumber1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <center> <h3> INTERVIEW OBSERVATIONS </h3> </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Appearance </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbWellGroomed' name='cbWellGroomed' className='add-only' value='Well Groomed' /> Well Groomed <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbCasual' name='cbCasual' className='add-only' value='Casual' /> Casual <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbDisheveled' name='cbDisheveled' className='add-only' value='Disheveled' /> Disheveled <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbUnkempt' name='cbUnkempt' className='add-only' value='Unkempt' /> Unkempt <br />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbBizarre' name='cbBizarre' className='add-only' value='Bizarre' /> Bizarre <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbInappropriate' name='cbInappropriate' className='add-only' value='Inappropriate' /> Inappropriate <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbMalodorous' name='cbMalodorous' className='add-only' value='Malodorous' /> Malodorous <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbPhysicalImpairment' name='cbPhysicalImpairment' className='add-only' value='Physical Impairment' /> Physical Impairment <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Build </span> </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbAverageBuild' name='cbAverageBuild' className='add-only' value='Average Build' /> Average Build <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbThin' name='cbThin' className='add-only' value='Thin' /> Thin <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbUnderweight' name='cbUnderweight' className='add-only' value='Underweight' /> Underweight <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbOverweight' name='cbOverweight' className='add-only' value='Overweight' /> Overweight <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbAverageHeight ' name='cbAverageHeight ' className='add-only' value='Average Height ' /> Average Height <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbTall' name='cbTall' className='add-only' value='Tall ' /> Tall <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbShort' name='cbShort' className='add-only' value='Short ' /> Short <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbObese' name='cbObese' className='add-only' value='Obese' /> Obese<br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Demeanor </span> </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbCooperative' name='cbCooperative' className='add-only' value='Cooperative' /> Cooperative <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbHostile' name='cbHostile' className='add-only' value='Hostile' /> Hostile <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbGuardedWithdrawn' name='cbGuardedWithdrawn' className='add-only' value='GuardedWithdrawn' /> GuardedWithdrawn <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbIndifferent' name='cbIndifferent' className='add-only' value='Indifferent' /> Indifferent <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbPreoccupied' name='cbPreoccupied' className='add-only' value='Preoccupied' /> Preoccupied <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbManipulative' name='cbManipulative' className='add-only' value='Manipulative' /> Manipulative <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbSeductive' name='cbSeductive' className='add-only' value='Seductive' /> Seductive <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbSuspicious' name='cbSuspicious' className='add-only' value='Suspicious' /> Suspicious <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Affect </span> </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbFullRange' name='cbFullRange' className='add-only' value='Full Range (Normal)' /> Full Range (Normal) <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbBlunted' name='cbBlunted' className='add-only' value='Blunted' /> Blunted <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbFlat' name='cbFlat' className='add-only' value='Flat' /> Flat <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbLabile' name='cbLabile' className='add-only' value='Labile' /> Labile <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbCongruent' name='cbCongruent' className='add-only' value='Congruent' /> Congruent <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbIncongruent' name='cbIncongruent' className='add-only' value='Incongruent' /> Incongruent <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbLabile' name='cbLabile' className='add-only' value='Labile' /> Labile <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbOther_1' name='cbOther1' className='add-only' value='Other' /> Other <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Mood </span> </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbEuthymic' name='cbEuthymic' className='add-only' value='Euthymic (Normal)' /> Euthymic (Normal)<br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbDysphoric' name='cbDysphoric' className='add-only' value='Dysphoric' /> Dysphoric <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbEuphoric' name='cbEuphoric' className='add-only' value='Euphoric' /> Euphoric <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbExpansive' name='cbExpansive' className='add-only' value='Expansive' /> Expansive <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbAnxiousNervous' name='cbAnxiousNervous' className='add-only' value='Anxious/Nervous' /> Anxious/Nervous <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbAngryIrritable' name='cbAngryIrritable' className='add-only' value='Angry/Irritable' /> Angry/Irritable <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbAgitated' name='cbAgitated' className='add-only' value='Agitated' /> Agitated <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbApathetic' name='cbApathetic' className='add-only' value='Apathetic' /> Apathetic <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbRelaxed' name='cbRelaxed' className='add-only' value='Relaxed' /> Relaxed <br />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_2' name='cbOther2' className='add-only' value='Other' /> Other: 7NBSP;
                            <input id='txtOther_2' name='txtOther_2' type='text' className='add-only w-250 custom-add-only' />
                        </td>

                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Eye Contact </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbAverage' name='cbAverage' className='add-only' value='Average' /> Average <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbDecreased' name='cbDecreased' className='add-only' value='Decreased' /> Decreased <br />
                        </td>
                        <td className='w-180'> <input type='checkbox' id='cbAvoidant' name='cbAvoidant' className='add-only' value='Avoidant' /> Avoidant <br />
                        </td>
                        <td className='w-190'> <input type='checkbox' id='cbIncreased' name='cbIncreased' className='add-only' value='Increased' /> Increased <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Speech </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbClear' name='cbClear' className='add-only' value='Clear' /> Clear <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbSlurred' name='cbSlurred' className='add-only' value='Slurred' /> Slurred <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbMumbled' name='cbMumbled' className='add-only' value='Mumbled' /> Mumbled <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbPressured' name='cbPressured' className='add-only' value='Pressured' /> Pressured <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbRapid' name='cbRapid' className='add-only' value='Rapid' /> Rapid <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbSlow' name='cbSlow' className='add-only' value='Slow' /> Slow <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbLoud' name='cbLoud' className='add-only' value='Loud' /> Loud <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbQuietWhispered' name='cbQuietWhispered' className='add-only' value='Quiet/Whispered' /> Quiet/Whispered <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbHesitant' name='cbHesitant' className='add-only' value='Hesitant' /> Hesitant <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbEmotional' name='cbEmotional' className='add-only' value='Emotional' /> Emotional <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbTalkative' name='cbTalkative' className='add-only' value='Talkative' /> Talkative <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbTerse' name='cbTerse' className='add-only' value='Terse' /> Terse <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Thought Process </span> </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbLogical' name='cbLogical' className='add-only' value='Logical' /> Logical <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbCoherent' name='cbCoherent' className='add-only' value='Coherent' /> Coherent <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbTight' name='cbTight' className='add-only' value='Tight' /> Tight <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbLinear' name='cbLinear' className='add-only' value='Linear' /> Linear <br />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbDisorganized' name='cbDisorganized' className='add-only' value='Disorganized' /> Disorganized <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbFlightOfIdeas' name='cbFlightOfIdeas' className='add-only' value='Flight of Ideas' /> Flight of Ideas <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbLooseAssociations' name='cbLooseAssociations' className='add-only' value='Loose Associations' /> Loose Associations <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbWordSalad' name='cbWordSalad' className='add-only' value='Word Salad' /> Word Salad <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Thought Content </span> </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbWithinNormalLimits' name='cbWithinNormalLimits' className='add-only' value='Within Normal Limits' /> Within Normal Limits <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbHallucinations' name='cbHallucinations' className='add-only' value='Hallucinations' /> Hallucinations <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbDelusions ' name='cbDelusions ' className='add-only' value='Delusions ' /> Delusions  <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbPersecutionIdeas' name='cbPersecutionIdeas' className='add-only' value='Persecution Ideas' /> Persecution Ideas <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbSuicidalIdeation' name='cbSuicidalIdeation' className='add-only' value='Suicidal Ideation' /> Suicidal Ideation <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbHomicidalIdeation' name='cbHomicidalIdeation' className='add-only' value='Homicidal Ideation' /> Homicidal Ideation <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbDerealization ' name='cbDerealization ' className='add-only' value='Derealization ' /> Derealization  <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbDepersonalization ' name='cbDepersonalization ' className='add-only' value='Depersonalization ' /> Depersonalization  <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbIdeasOfReference' name='cbIdeasOfReference' className='add-only' value='Ideas of Reference' /> Ideas of Reference <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbPreoccupations' name='cbPreoccupations' className='add-only' value='Preoccupations' /> Preoccupations <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbStrangeExperiences' name='cbStrangeExperiences' className='add-only' value='Strange Experiences' /> Strange Experiences <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbObsessions' name='cbObsessions' className='add-only' value='Obsessions' /> Obsessions <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Insight </span> </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbGood ' name='cbGood ' className='add-only' value='Good ' /> Good  <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbLimited ' name='cbLimited ' className='add-only' value='Limited ' /> Limited  <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbPoor ' name='cbPoor ' className='add-only' value='Poor ' /> Poor  <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbUnclear ' name='cbUnclear ' className='add-only' value='Unclear ' /> Unclear  <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Judgment </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbGood_1' name='cbGood1' className='add-only' value='Good' /> Good  <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbLimited_1' name='cbLimited1' className='add-only' value='Limited' /> Limited  <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbPoor_1' name='cbPoor1' className='add-only' value='Poor' /> Poor  <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbUnclear_1' name='cbUnclear1' className='add-only' value='Unclear' /> Unclear  <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Memory </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbRemoteLongTerm)' name='cbRemoteLongTerm)' className='add-only' value='Remote (long-term)' /> Remote (long-term)  <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbRecentShortTerm)' name='cbRecentShortTerm)' className='add-only' value='Recent (short-term)' /> Recent (short-term)  <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbImmediate' name='cbImmediate' className='add-only' value='Immediate' /> Immediate  <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbImpaired' name='cbImpaired' className='add-only' value='Impaired' /> Impaired <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Orientation </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-190'>
                            <input type='checkbox' id='cbPerson' name='cbPerson' className='add-only' value='Person ' /> Person  <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbPlace' name='cbPlace' className='add-only' value='Place' /> Place  <br />
                        </td>
                        <td className='w-180'>
                            <input type='checkbox' id='cbTime' name='cbTime ' className='add-only' value='Time' /> Time  <br />
                        </td>
                        <td className='w-190'>
                            <input type='checkbox' id='cbSituation' name='cbSituation' className='add-only' value='Situation' /> Situation  <br />
                        </td>

                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> BEHAVIORAL OBSERVATIONS: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id="BehavioralObservations" name="BehavioralObservations"> </textarea>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> SUMMARY: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id="Summary" name="Summary"> </textarea>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> DIAGNOSTIC JUSTIFICATION: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id="DiagnosticJustification" name="DiagnosticJustification"> </textarea>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <center> <b> DIAGNOSTICS </b> </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'> <b> VERIFIED DIAGNOSIS </b> (include any/all specifiers) </span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'> <b> ICD-10 CODE </b> </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-500'> <input type='text' id='txtVerifiedDiagnosis_1' name='txtVerifiedDiagnosis1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtIcdCode_1' name='txtIcdCode1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-500'> <input type='text' id='txtVerifiedDiagnosis_2' name='txtVerifiedDiagnosis2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtIcdCode_2' name='txtIcdCode2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-500'> <input type='text' id='txtVerifiedDiagnosis_3' name='txtVerifiedDiagnosis3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtIcdCode_3' name='txtIcdCode3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> <b> RECOMMENDATIONS: </b> </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' id='cbBehavioralHealthAssessment' name='cbBehavioralHealthAssessment' className='add-only' value='Behavioral Health Assessment' /> Behavioral Health Assessment <br />
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' id='cbIndividualOutpatientServices' name='cbIndividualOutpatientServices' className='add-only' value='Individual Outpatient Services' /> Individual Outpatient Services <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' id='cbCrisisIntervention' name='cbCrisisIntervention' className='add-only' value='Crisis Intervention' /> Crisis Intervention <br />
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' id='cbServicePlanDevelopment' name='cbServicePlanDevelopment' className='add-only' value='Service Plan Development' /> Service Plan Development <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' id='cbFamilyOutpatientServicesCounseling' name='cbFamilyOutpatientServicesCounseling' className='add-only' value='Family Outpatient Services - Counseling' /> Family Outpatient Services - Counseling <br />
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' id='cbIntensiveFamilyInterventionIfiC&A' name='cbIntensiveFamilyInterventionIfiC&A' className='add-only' value='Intensive Family Intervention (IFI) (C&A)' /> Intensive Family Intervention (IFI) (C&A) <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' id='cbDiagnosticAssessment' name='cbDiagnosticAssessment' className='add-only' value='Diagnostic Assessment' /> Diagnostic Assessment <br />
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' id='cbFamilyOutpatientServicesSkillsTraining' name='cbFamilyOutpatientServicesSkillsTraining' className='add-only' value='Family Outpatient Services - Skills Training' /> Family Outpatient Services - Skills Training <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' id='cbCaseManagementAdult' name='cbCaseManagementAdult' className='add-only' value='Case Management (adult)' /> Case Management (adult) <br />
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' id='cbPsychiatricTreatment' name='cbPsychiatricTreatment' className='add-only' value='Psychiatric Treatment' /> Psychiatric Treatment <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' id='cbAddictiveDiseaseSupportServicesAdult' name='cbAddictiveDiseaseSupportServicesAdult' className='add-only' value='Community Support Services (CSI) (C&A)' /> Community Support Services (CSI) (C&A) <br />
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' id='cbNursingServices' name='cbNursingServices' className='add-only' value='Nursing Services' /> Nursing Services <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAddictiveDiseaseSupportServicesAdult' name='cbAddictiveDiseaseSupportServicesAdult' className='add-only' value='Psychosocial Rehabilitation - Individual (PSR-I) (adult)' /> Psychosocial Rehabilitation - Individual (PSR-I) (adult) <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbReferForMedicalEvaluation' name='cbReferForMedicalEvaluation' className='add-only' value='Refer for a medical evaluation to assess the need for medication management and supervision and to assist in planning for related wellness and medical goals.' /> <b> Refer for a medical evaluation </b> to assess the need for medication management and supervision and to assist in planning for related wellness and medical goals. <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEncourageParticipationInMentorshipOpportunities' name='cbEncourageParticipationInMentorshipOpportunities' className='add-only' value='Encourage participation in mentorship opportunities and/or peer support groups that would further support challenging problem behaviors or symptoms.' /> Encourage participation in mentorship opportunities and/or peer support groups that would further support challenging problem behaviors or symptoms. <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLinkageToCommunityResourcesAsNeeded' name='cbLinkageToCommunityResourcesAsNeeded' className='add-only' value='Linkage to community resources as needed.' /> Linkage to community resources as needed. <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            If I may be of further assistance, please feel free to contact me.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            Respectfully Submitted,
                        </td>
                    </tr>


                </table>
                {/* <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Clinician Name <br /> Clinician Licensure
                        </td>
                        <td className='small w-375'> Date </td>
                    </tr>

                </table> */}





            </div>
        </form>

    )
}